
<div class="tabs" [class.tabs__text-underline]="underline">
  <div class="tab" *ngFor="let tab of tabs; index as index"
    [style]="tabStyle" [class.selected]="index == selectedTabIndex"
    (click)="setSelectedTab(index)">
    <div class="mr-2">
      <trg-checkbox
        appearance="circle"
        size="tiny" [readonly]="disabled" [hideBorder]="true"
        [value]="index == selectedTabIndex"></trg-checkbox>
    </div>
    <span class="title text-ellipsis">{{tab}}</span>
  </div>
</div>
